import { Model } from '@vuex-orm/core';
import AddressTypeAPI from '@/api/AddressTypeAPI';
import { SessionStorageService as ss } from '@/services/SessionStorageService';
import { AddressTypeFields } from '@/interfaces/AddressType';

export default class AddressType extends Model {
    public static entity = 'addressType';

    public static fields() {
        return {
            id: this.string(null),
            code: this.attr(null),
            name: this.attr(null),
            info: this.attr(null),
            requiredFields: this.attr(null),
            isCompany: this.boolean(false),
        };
    }

    public static async getAll() {
        let addressTypes;

        if (ss.has('addressTypes')) {
            addressTypes = ss.getAndParse('addressTypes');
        } else {
            try {
                addressTypes = await AddressTypeAPI.getAll();
                addressTypes = addressTypes.data;

                ss.stringifyAndSave('addressTypes', addressTypes);
            } catch (e) {
                return Promise.reject(e);
            }
        }

        this.create({
            data: addressTypes,
        });
        return Promise.resolve();
    }

    public static async getAllCodes() {
        let codes;
        try {
            codes = await AddressTypeAPI.getAllCodes();
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(codes);
    }

    public static async getById(addressTypeId: string) {
        let addressType;
        try {
            addressType = await AddressTypeAPI.getById(addressTypeId);
        } catch (e) {
            return Promise.reject(e);
        }
        this.create({
            data: addressType.data,
        });
        return Promise.resolve(addressType);
    }

    public static async updateExisting(addressTypeId: string, addressTypeInfo: AddressTypeFields) {
        let addressType;
        try {
            addressType = await AddressTypeAPI.update(addressTypeId, addressTypeInfo);
        } catch (e) {
            return Promise.reject(e);
        }
        this.create({
            data: addressType.data,
        });

        // Update local storage
        const addressTypes = ss.getAndParse('addressTypes') || [];
        const index = addressTypes.findIndex((at: any) => at.id === addressTypeId);
        if (index !== -1) {
            addressTypes[index] = addressType.data;
            ss.stringifyAndSave('addressTypes', addressTypes);
        }

        return Promise.resolve(addressType);
    }

    public static async createNew(addressTypeInfo: AddressTypeFields) {
        let addressType;
        try {
            addressType = await AddressTypeAPI.create(addressTypeInfo);
        } catch (e) {
            return Promise.reject(e);
        }
        this.create({
            data: addressType.data,
        });

        // Update local storage
        const addressTypes = ss.getAndParse('addressTypes') || [];
        addressTypes.push(addressType.data);
        ss.stringifyAndSave('addressTypes', addressTypes);

        return Promise.resolve(addressType);
    }

    public static async deleteExisting(addressTypeId: string) {
        try {
            await AddressTypeAPI.delete(addressTypeId);
        } catch (e) {
            return Promise.reject(e);
        }
        await AddressType.delete(addressTypeId);

        // Update local storage
        const addressTypes = ss.getAndParse('addressTypes') || [];
        const updatedAddressTypes = addressTypes.filter((at: any) => at.id !== addressTypeId);
        ss.stringifyAndSave('addressTypes', updatedAddressTypes);

        return Promise.resolve();
    }

    public id!: string;
    public code!: string | null;
    public name!: string;
    public info!: string | null;
    public requiredFields!: string[] | null;
    public isCompany!: boolean;
}
